import React from "react";
import "./divider.scss";

const Divider = () => {
  return <div className="divider" />;
};

export default Divider;
